var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickResultInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#1E2C72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9828 20V9.09091H14.0083V20H10.9828ZM12.5027 7.68466C12.0529 7.68466 11.667 7.53551 11.345 7.23722C11.0278 6.93419 10.8691 6.57197 10.8691 6.15057C10.8691 5.7339 11.0278 5.37642 11.345 5.07812C11.667 4.77509 12.0529 4.62358 12.5027 4.62358C12.9525 4.62358 13.336 4.77509 13.6532 5.07812C13.9752 5.37642 14.1362 5.7339 14.1362 6.15057C14.1362 6.57197 13.9752 6.93419 13.6532 7.23722C13.336 7.53551 12.9525 7.68466 12.5027 7.68466Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickResultInfo);
export default __webpack_public_path__ + "static/media/quickResultInfo.9484e6718a3116f50d223d02506411f7.svg";
export { ForwardRef as ReactComponent };